export default {
	// list: 'BuyoutPartner',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		PartnerID: {
			class: 'value',
			dataName: 'PartnerID',
			type: 'string',
			title: 'Partner ID',
			width: 125,
			hidden: false,
			readOnly: false,
		},
		PartnerName: {
			class: 'value',
			dataName: 'PartnerName',
			type: 'string',
			title: 'Partner Name',
			width: 200,
			hidden: false,
			readOnly: false,
		},
		PartnerStatus: {
			class: 'value',
			dataName: 'PartnerStatus',
			type: 'string',
			title: 'Partner Status',
			width: 125,
			hidden: false,
			readOnly: false
		},
		LeaveDate: {
			class: 'value',
			dataName: 'LeaveDate',
			type: 'date',
			title: 'Termination Date',
			width: 125,
			hidden: false,
			readOnly: false
		},
		StartBuyout: {
			class: 'value',
			dataName: 'StartBuyout',
			type: 'string',
			title: 'Buyout started',
			width: 100,
			hidden: true,
			readOnly:false
		},
		StartRetire:{
			class: 'value',
			dataName: 'StartRetire',
			type: 'string',
			title: 'Retirement started',
			width: 100,
			hidden: true,
			readOnly:false
		}
		
	}
}